import { composeName } from "../utils";
export var ANIMATION_DURATION = '0.5s';
export var ANIMATION_DURATION_FAST = '0.2s';
export var ANIMATION_DURATION_SUPER_FAST = '0.1s'; // class name

export var classPrefix = composeName('prism');
export var _ = composeName('-');